import { useMutation, useQuery } from "@tanstack/react-query";
import useAxiosInstance from "./axiosInstance.utils";
import { errorFormat } from "./handleError.utils";
import { onSuccessMessage, queryClient } from "./reactQuery.utils";

/**
 * :::::::MUTATIONS:::::::::::
 */

export function useCreateCarInfoTypeMutation(keyData) {
  const { postApi } = useAxiosInstance();
  async function createCarInfoTypeApi(data) {
    try {
      const api = `/car-info-type`;
      const apiResponse = await postApi(api, data);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["createCarInfoTypeApi", ...keyData],
    mutationFn: (data) => createCarInfoTypeApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("car-info-types");
      onSuccessMessage(data, 201);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, createCarInfoType: mutateAsync };
}

export function useUpdateCarInfoTypeMutation(keyData) {
  const { putApi } = useAxiosInstance();
  async function updateCarInfoTypeApi(data) {
    try {
      const api = `/car-info-type`;
      const apiResponse = await putApi(api, data);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }
  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["updateCarInfoTypeApi", ...keyData],
    mutationFn: (data) => updateCarInfoTypeApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("car-info-types");
      onSuccessMessage(data, 200);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, updateCarInfoType: mutateAsync };
}

export function useDeleteCarInfoTypeMutation(keyData) {
  const { deleteApi } = useAxiosInstance();
  async function deleteCarInfoTypeApi(id) {
    try {
      const api = `/car-info-type/${id}`;
      const apiResponse = await deleteApi(api);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["deleteCarInfoTypeApi", ...keyData],
    mutationFn: (data) => deleteCarInfoTypeApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("car-info-types");
      onSuccessMessage(data, 200);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, deleteCarInfoType: mutateAsync };
}

/**
 * :::::::QUERIES:::::::::::
 */
export function useGetAllCarInfoTypeQuery({ query, options = {}, key = "" }) {
  const { getApi } = useAxiosInstance();
  async function getAllCarInfoTypeApi(query) {
    try {
      const api = `/car-info-types${query ?? ""}`;
      const apiResponse = await getApi(api);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { data, isPending: loading } = useQuery({
    queryKey: [`getAllCarInfoType-${query ?? ""}${key ? "-" + key : ""}`],
    queryFn: () => getAllCarInfoTypeApi(query),
    ...options
  });
  const newData = data?.data?.data ?? {};
  return { data: newData, loading };
}
